import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"



/* Page 404 */
class Page404 extends Component {

    render = () => {
        return (
            <div className="page-404">
                <h1>Page 404</h1>
                <p>{t("page404.text")}</p>
            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Page404)